import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import DesignTab from "./DesignTab/DesignTab";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setProjectNoInRedux } from "./DesignTab/designSlice";
import SettingsPage from "./SettingPage/SettingsPage";
import { RoomTab } from "./RoomTab/RoomTab";
import { useHydrateProjectTabFromUrl } from "./hooks/useHydradeProjectTabFromUrl";
import { useGetMultiplacerProjectsSingleProjectQuery } from "../openapi";

export const ProjectPage: React.FC = () => {
  const projectNo = useLocation().pathname.split("/")[1];

  const projectNoIs8Digits = /^\d{8}$/.test(projectNo);
  useHydrateProjectTabFromUrl();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setProjectNoInRedux(Number(projectNo)));
  }, [projectNo, dispatch]);

  const { data: project } = useGetMultiplacerProjectsSingleProjectQuery(
    {
      projectNo: Number(projectNo),
    },
    {
      skip: !projectNoIs8Digits,
    }
  );

  return (
    <>
      {!projectNoIs8Digits && <div>Ugyldig prosjektnummer i URL</div>}
      <Routes>
        {project != null && (
          <>
            <Route path={"/design"} element={<DesignTab />} />
            <Route path={"/room"} element={<RoomTab />} />
            <Route path={"/settings"} element={<SettingsPage />} />
          </>
        )}
      </Routes>
    </>
  );
};
